<template>

<core-panel>

	<template v-slot:head>

		<h1>First Encounters</h1>

		<p>All games that have entered {{ your }} universe, most recent first.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in arrivals" :item="gameData(item.g)" :key="index" :subtext="subtext(item.date)" v-on:click.native="goToGame(item.g)">

			<span class="arrival-tag" :data-theme="item.type">{{ item.type }}</span>

		</app-game>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'arrivals',
			arrivals: []
		}

	},

	computed: {

		your: function() {

			return this.$store.getters['context/your']

		}

	},

	methods: {

		response: function(json) {

			this.arrivals = json.arrivals

		},

		gameData: function(id) {

			return this.$store.getters['data/games/associated'][id] || {}

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })
			this.$pubsub.$emit('panel.close')

		},

		subtext: function(value) {

			return this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		}

	}

}

</script>

<style scoped>

.arrival-tag {
	font-size: 13px;
	color: #fff;
	padding: 4px 8px;
	border-radius: 4px;
	font-weight: 500;
	margin-left: 8px;
}

.arrival-tag[data-theme="Own"] {
	background-color: #4881bb;
}

.arrival-tag[data-theme="Previously Owned"] {
	background-color: #7a5fbf;
}

.arrival-tag[data-theme="Played"] {
	background-color: #2FC482;
}

.arrival-tag[data-theme="Rated"] {
	background-color: #f5a623;
}

.arrival-tag[data-theme="Wishlisted"] {
	background-color: #e85d75;
}

</style>
